export class ListingLoader {

    constructor() {

        let loaderWrap = document.querySelector('.loader-wrap');

        if(typeof loaderWrap !== 'undefined' && loaderWrap !== null) {
            this.loaderTrigger = loaderWrap.querySelector('.listing-load-more');
            this.loaderResults = loaderWrap.querySelector('.results');
            this.loading = false;
            this.listing = document.querySelector('.results-row');

            if (this.loaderTrigger) {
                this.initLoaderTrigger();
            }
        }
    }

    initLoaderTrigger() {
        this.loaderTrigger.addEventListener('click', e => this.loadMoreTriggered());
    }

    loadMoreTriggered() {
        if(!this.loaderTrigger.classList.contains('disabled')) {
            let currentPage = parseInt(this.loaderTrigger.getAttribute('data-current')),
                maxPages = parseInt(this.loaderTrigger.getAttribute('data-pages')),
                nextPage = currentPage + 1,
                category = this.loaderTrigger.getAttribute('data-category'),
                type = this.loaderTrigger.getAttribute('data-type');

            if (nextPage === maxPages) {
                this.disableTrigger();
            }

            if (nextPage <= maxPages) {
                this.ajaxLoad(nextPage, type, category);
            } else {
                this.disableTrigger();
            }
        }
    }

    ajaxLoad(page, type, category = '') {
        this.loading = true;
        this.loaderTrigger.classList.add('loading');

        let request = new XMLHttpRequest();
        request.open('GET', '/wp-json/app/v1/get?page=' + page + '&type=' + type + '&category=' + category, true);

        let self = this;
        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                // Success!
                this.loading = false;
                let data = JSON.parse(request.responseText);
                if(data.status  && data.status == 'success') {
                    self.updateListing(data);
                    self.loaderTrigger.classList.remove('loading');
                } else {
                    // TODO Error
                }


            } else {
                // TODO Error
            }
        };

        request.onerror = function() {
            // TODO Error
        };

        request.send();
    }

    disableTrigger() {
        this.loaderTrigger.classList.add('disabled');
    }

    updateListing(data) {
        let self = this;
        this.loaderTrigger.setAttribute('data-current', data.loader.currentPage);
        this.loaderResults.innerHTML = 'Showing ' + data.loader.showingNumber + ' of ' + data.loader.numberOfPosts + ' results';

        data.items.forEach(function(item){
            self.addItem(item);
        });

    }

    addItem(item) {
        let itemEl = document.createElement('div');
        itemEl.classList.add('col-xs-12','col-sm-6','col-md-3', 'hidden');

        let imageEl = document.createElement('div');
        imageEl.classList.add('image');
        if (item.image.class) {
            imageEl.classList.add(item.image.class);
        }
        imageEl.style.backgroundImage = 'url(' + item.image.url + ')';
        
        if(item.colour) {
            imageEl.style.backgroundColor = item.colour;
        }

        let nameEl = document.createElement('div');
        nameEl.classList.add('name');
        nameEl.innerHTML = item.title;

        itemEl.appendChild(imageEl);
        itemEl.appendChild(nameEl);

        if(item.url) {
            let linkEl = document.createElement('a');
            linkEl.classList.add('overlay-link');
            linkEl.setAttribute('href', item.url);
            itemEl.appendChild(linkEl);
        }

        if (item.subtext) {
            let subtextEl = document.createElement('div');
            subtextEl.classList.add('subtext');
            subtextEl.innerHTML = item.subtext;
            itemEl.appendChild(subtextEl);
        }

        setTimeout(function(){
            itemEl.classList.remove('hidden');
        }, 200);

        this.listing.appendChild(itemEl);
    }

}


// WEBPACK FOOTER //
// ./assets/sass/shared/listing.js